import './App.css';
import deltaLogo from './og-image.png';
import expertsImg from './imgs/experts.jpg';
import beerTastingImg from './imgs/beer.webp';
import porkMafiaImg from './imgs/porkmafia.jpg';
// import pettingZooImg from './imgs/pettingzoo.jpg';
import shaneTerryImg from './imgs/shaneterry.jpg';
// import carnivalGamesImg from './imgs/carnival.avif';
import interior1 from './imgs/interior-1.jpg';
import interior2 from './imgs/interior-2.jpg';
import interior3 from './imgs/interior-3.jpg';
import exterior1 from './imgs/exterior-1.jpg';
import exterior2 from './imgs/exterior-w.jpg';
import exterior3 from './imgs/exterior-3.jpg';
import { useState, useEffect, useRef } from 'react';
import 'animate.css';
import emailjs from '@emailjs/browser';
import { EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, EMAILJS_PUBLIC_KEY } from './services/emailjs';

function Countdown({ targetDate }) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = +new Date(targetDate) - +new Date();
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const pad = (num) => String(num).padStart(2, '0');

  return (
    <div className="countdown-wrapper">
      <div className="countdown">
        <div className="countdown__item">
          <span className="countdown__value">{pad(timeLeft.days)}</span>
          <span className="countdown__label">Days</span>
        </div>
        <span className="countdown__separator">:</span>
        <div className="countdown__item">
          <span className="countdown__value">{pad(timeLeft.hours)}</span>
          <span className="countdown__label">Hours</span>
        </div>
        <span className="countdown__separator">:</span>
        <div className="countdown__item">
          <span className="countdown__value">{pad(timeLeft.minutes)}</span>
          <span className="countdown__label">Minutes</span>
        </div>
        <span className="countdown__separator">:</span>
        <div className="countdown__item">
          <span className="countdown__value">{pad(timeLeft.seconds)}</span>
          <span className="countdown__label">Seconds</span>
        </div>
      </div>
    </div>
  );
}


function TimelineItem({ children, delay = 0 }) {
  const [isVisible, setIsVisible] = useState(false);
  const itemRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isVisible) {
            setIsVisible(true);
          }
        });
      },
      {
        threshold: 0.1, // Trigger when 10% of the item is visible
        rootMargin: '0px 0px -50px 0px' // Start slightly before it enters viewport
      }
    );

    const node = itemRef.current;
    if (node) {
      observer.observe(node);
    }

    return () => {
      if (node) {
        observer.unobserve(node);
      }
    };
  }, [isVisible]);

  return (
    <div
      ref={itemRef}
      className={`timeline__item ${isVisible ? 'animate__animated animate__slideInLeft' : ''}`}
      style={{
        opacity: isVisible ? 1 : 0,
        animationDelay: `${delay}ms`
      }}
    >
      {children}
    </div>
  );
}

function AnimatedCountdown({ targetDate }) {
  const [isVisible, setIsVisible] = useState(false);
  const [animationCount, setAnimationCount] = useState(0);
  const countdownRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isVisible) {
            setIsVisible(true);
            // Trigger first animation immediately
            setAnimationCount(1);
            
            // Trigger second animation after first one completes
            setTimeout(() => {
              setAnimationCount(2);
            }, 1000); // Wait for first animation to finish (tada is ~1s)
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    const node = countdownRef.current;
    if (node) {
      observer.observe(node);
    }

    return () => {
      if (node) {
        observer.unobserve(node);
      }
    };
  }, [isVisible]);

  return (
    <div
      ref={countdownRef}
      className={`countdown-wrapper ${isVisible && animationCount > 0 ? 'animate__animated animate__tada' : ''}`}
      key={animationCount} // Force re-render for second animation
    >
      <Countdown targetDate={targetDate} />
    </div>
  );
}

function App() {
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();
    
    // Store form reference before async operations
    const formElement = e.currentTarget;
    
    try {
      setLoading(true);
      
      const form = new FormData(formElement);
      const name = form.get('name') || '';
      const email = form.get('email') || '';
      const phone = form.get('phone') || '';
      const address = form.get('address') || '';
      const registrationType = form.get('registrationType') || 'Attendee';
      const subject = form.get('subject') || 'South Delta Home Show Registration';
      const message = form.get('message') || '';

      console.log('Sending registration:', {
        name,
        email,
        phone,
        address,
        subject,
        message
      });

      // Prepare template parameters
      const templateParams = {
        to_name: "South Delta Home Show",
        from_name: name,
        from_email: email,
        phone: phone,
        registrationType,
        address: address,
        subject: subject,
        message: message,
        company: 'South Delta Home Show',
        to_emails: 'pacificodesystems@gmail.com, info@southdeltahomeshow.ca'
      };

      // Send email using EmailJS
      const response = await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams,
        EMAILJS_PUBLIC_KEY
      );

      console.log('Email sent successfully:', response);
      
      // Show success animation
      setShowSuccess(true);
      
      // Reset form
      formElement.reset();
      
      // Hide success message after 4 seconds
      setTimeout(() => {
        setShowSuccess(false);
      }, 10000);

    } catch (error) {
      console.error('Error sending registration:', error);
      alert('There was a problem sending your registration. Please try emailing us directly at info@southdeltahomeshow.ca');
    } finally {
      setLoading(false);
    }
  };


  const handleAddToCalendar = () => {
    // Event details
    const eventTitle = "South Delta Home Show";
    const eventLocation = "The Red Barn at Southlands Tsawwassen, 6333 Market Ave, Delta, BC";
    const eventDescription = "Join us for a full day of home improvement inspiration, expert advice, and family-friendly entertainment. Featuring local experts, beer garden, food trucks, live music. Admission is FREE. One day only: April 10th, 2027, 11:00 am - 6:00 pm at the Red Barn at the Southlands Tsawwassen.";
    const startDate = "20270410T110000"; // April 10th, 2027, 11:00 AM
    const endDate = "20270410T180000";   // April 10th, 2027, 6:00 PM
    
    // Create ICS file content
    const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//South Delta Home Show//EN
CALSCALE:GREGORIAN
METHOD:PUBLISH
BEGIN:VEVENT
DTSTART:${startDate}
DTEND:${endDate}
DTSTAMP:${new Date().toISOString().replace(/[-:]/g, '').split('.')[0]}Z
SUMMARY:${eventTitle}
DESCRIPTION:${eventDescription}
LOCATION:${eventLocation}
STATUS:CONFIRMED
SEQUENCE:0
BEGIN:VALARM
TRIGGER:-PT24H
ACTION:DISPLAY
DESCRIPTION:Reminder: ${eventTitle} tomorrow
END:VALARM
END:VEVENT
END:VCALENDAR`;

    // Create blob and download
    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', 'south-delta-home-show.ics');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="App">
      <header className="nav">
        <div className="container nav__inner">
          <a href="#top" className="brand">
            {/* <span className="brand__mark" aria-hidden>SD</span> */}
            <img src={deltaLogo} alt="South Delta Home Show" className="brand__icon" />
            <span className="brand__text">South Delta Home Show</span>
          </a>
          <nav className="nav__links">
            <a href="#event">Event</a>
            <a href="#entertainment">Entertainment</a>
            <a href="#videos">Videos</a>
            <a href="#register" className="btn btn--primary">Register</a>
          </nav>
        </div>
      </header>

      <main id="top">
        <section className="hero">
          <div className="hero__slideshow" aria-hidden="true">
            <div className="hero__slide hero__slide--1" style={{ backgroundImage: `url(${interior1})` }}></div>
            <div className="hero__slide hero__slide--2" style={{ backgroundImage: `url(${interior2})` }}></div>
            <div className="hero__slide hero__slide--3" style={{ backgroundImage: `url(${exterior1})` }}></div>
            <div className="hero__slide hero__slide--4" style={{ backgroundImage: `url(${exterior2})` }}></div>
            <div className="hero__slide hero__slide--5" style={{ backgroundImage: `url(${exterior3})` }}></div>
            <div className="hero__slide hero__slide--6" style={{ backgroundImage: `url(${interior3})` }}></div>
          </div>
          <div className="hero__overlay"></div>
          <div className="container hero__grid">
            <div className="hero__copy">
              <div className="hero__icon-container flex items-center gap-2">
                <img src={deltaLogo} alt="South Delta Home Show" className="hero__icon" />
                {/* <h1>South Delta Home Show</h1> */}
              </div>
              <p className="hero__kicker">Saturday, April 10, 2027 · 11:00 am — 6:00 pm</p>
              <p className="hero__sub">The Red Barn at Southlands Tsawwassen  <br></br> <strong>Admission is FREE</strong></p>
              <div className="hero__cta">
                <a href="#register" className="btn btn--primary">Register Today</a>
                <a
                  className="btn btn--secondary"
                  href="https://www.google.com/maps/search/?api=1&query=6333+Market+Ave%2C+Delta%2C+BC"
                  target="_blank"
                  rel="noreferrer"
                >
                  Get Directions
                </a>
              </div>
              <div className="hero__meta">
                <span>6333 Market Ave, Delta, BC</span>
                <span>info@southdeltahomeshow.ca · (604) 365‑5225</span>
              </div>
            </div>
            
            <div className="hero__right">
              <div className="hero__visual" aria-hidden>
                <div className="hero__card">
                  <div className="hero__card-line" />
                  <div className="hero__card-badge">April 10</div>
                  <div className="hero__card-body">
                    <h3>Connect. Discover. Refresh.</h3>
                    <p>Meet local experts and explore what's new for spring and summer.</p>
                  </div>
                </div>
              </div>
              <AnimatedCountdown targetDate="2027-04-10T11:00:00" />
            </div>
          </div>
        </section>

        <section id="event" className="section">
          <div className="container">
            <h2>Event Details</h2>
            <p className="section__lede" style={{ textAlign: 'center', maxWidth: '600px', margin: '0 auto 24px' }}>
              Join us for a full day of home improvement inspiration, expert advice, and family-friendly entertainment.
            </p>
            
            {/* Add this button */}
            <div style={{ textAlign: 'center', marginBottom: '40px' }}>
              <button 
                onClick={handleAddToCalendar} 
                className="btn btn--primary add-to-calendar-btn"
              >
                📅 Add to Calendar
              </button>
            </div>

            <div className="timeline">
              <TimelineItem delay={0}>
                <div className="timeline__dot" />
                <div>
                  <h3>11:00 AM · Doors Open</h3>
                  <p>Welcome to the venue—gather and speak with local vendors.</p>
                </div>
              </TimelineItem>
              <TimelineItem delay={100}>
                <div className="timeline__dot" />
                <div>
                  <h3>11:00 AM – 6:00 PM · Networking Session</h3>
                  <p>Browse, learn what’s new, and enjoy special promotions and raffles.</p>
                </div>
              </TimelineItem>
              <TimelineItem delay={200}>
                <div className="timeline__dot" />
                <div>
                  <h3>11:00 AM – 6:00 PM · Entertainment</h3>
                  <p>Complimentary beer garden. First 100 guests get a free meal.</p>
                </div>
              </TimelineItem>
              <TimelineItem delay={300}>
                <div className="timeline__dot" />
                <div>
                  <h3>6:00 PM · Doors Close</h3>
                  <p>The event concludes. Thank you for joining us!</p>
                </div>
              </TimelineItem>
            </div>
            
            <div className="other-event-section">
              <p>Check out our other event:</p>
              <a 
                href="https://www.wrsshomeshow.ca/" 
                target="_blank"
                rel="noopener noreferrer"
                className="other-event-btn"
              >
                White Rock & South Delta Home Show
              </a>
            </div>

          </div>
        </section>

        <section id="entertainment" className="section section--alt">
          <div className="container">
            <h2>Entertainment & Experiences</h2>
            <p className="section__lede">Featuring local businesses specializing in home‑related services, plus on‑site experiences.</p>
            <div className="grid">
              <article className="card">
                <img src={expertsImg} alt="Local Experts" loading="lazy" decoding="async" />
                <h3>Local Experts</h3>
                <p>Connect with South Delta’s best home service specialists.</p>
              </article>
              <article className="card">
              <img src={beerTastingImg} alt="Local Experts" />

                <h3>Beer Tasting</h3>
                <p>Beer Garden serving from 11:00 am – 5:30 pm.</p>
              </article>
              <article className="card">
                <img src={porkMafiaImg} alt="Food Trucks" loading="lazy" decoding="async" />
                <h3>Food Trucks</h3>
                <p>The first 100 guests receive a free Pulled Pork Sandwich from Porkmafia.</p>
              </article>
              <article className="card">
              <img src={shaneTerryImg} alt="Local Experts" />

                <h3>Live Music: Shane Terry</h3>
                <p>Enjoy live performances throughout the day.</p>
              </article>
              {/* <article className="card">
                <img src={pettingZooImg} alt="Petting Zoo" loading="lazy" decoding="async" />
                <h3>Petting Zoo</h3>
                <p>FREE petting zoo by Cinemazoo with a variety of animals.</p>
              </article>
              <article className="card">
              <img src={carnivalGamesImg} alt="Local Experts" />

                <h3>Carnival Games</h3>
                <p>Have fun and support the Delta Community Animal Shelter.</p>
              </article> */}
            </div>
          </div>
        </section>

        <section id="videos" className="section">
          <div className="container">
            <h2>Videos</h2>
            <div className="grid grid--videos">

            <iframe width="560" className="video__iframe" height="315" src="https://www.youtube.com/embed/wM7GnFzqdc8?si=8khfpnMWdzmgCNKX" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

            <iframe width="560" className="video__iframe" height="315" src="https://www.youtube.com/embed/BAjjktJeQdM?si=BfyWFGOO_9qfXvxO" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

              <iframe width="560" className="video__iframe" height="315" src="https://www.youtube.com/embed/XLaV-pgLn1c?si=C3Ggi5CXBVSiv_3X" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> 


            </div>
          </div>
        </section>

        <section id="register" className="section section--alt">
          <div className="container">
            <h2>Register Today</h2>
            <p className="section__lede">
              Email <a href="mailto:info@southdeltahomeshow.ca">info@southdeltahomeshow.ca</a> or call <a href="tel:+16043655225">(604) 365‑5225</a>.
            </p>
            <form className="form" onSubmit={handleRegisterSubmit}>
            <div className="form__row">
                <label className="form__full">
                  I am registering as
                  <div className="radio-group">
                  <label className="radio-option">
                      <input 
                        type="radio" 
                        name="registrationType" 
                        value="Vendor" 
                        defaultChecked
                      />
                      <span className="radio-label">Vendor</span>
                    </label>
                    <label className="radio-option">
                      <input 
                        type="radio" 
                        name="registrationType" 
                        value="Attendee" 
                         
                      />
                      <span className="radio-label">Attendee</span>
                    </label>
                    
                  </div>
                </label>
              </div>
              <div className="form__row">
                <label>
                  Name
                  <input name="name" type="text" placeholder="Enter your name" required />
                </label>
                <label>
                  Email
                  <input name="email" type="email" placeholder="Enter your email" required />
                </label>
              </div>
              <div className="form__row">
                <label>
                  Phone
                  <input name="phone" type="tel" placeholder="Enter your phone number" />
                </label>
                <label>
                  Address
                  <input name="address" type="text" placeholder="Enter your address" />
                </label>
              </div>
              <div className="form__row">
                <label className="form__full">
                  Subject
                  <input name="subject" type="text" placeholder="Type the subject" />
                </label>
              </div>
              <div className="form__row">
                <label className="form__full">
                  Message
                  <textarea name="message" rows="5" placeholder="Type your message here..." />
                </label>
              </div>
              <div className="form__actions">
                <button type="submit" className="btn btn--primary" disabled={loading}>
                  {loading ? 'Sending...' : 'Send Registration'}
                </button>
                {/* <a href="mailto:info@southdeltahomeshow.ca" className="btn btn--ghost">Email Us</a> */}
              </div>
            </form>
            {showSuccess && (
              <div className="success-message animate__animated animate__bounceIn">
                <div className="success-checkmark">
                  <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                    <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                    <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                  </svg>
                </div>
                <h3>Registration Sent Successfully!</h3>
                <p>We'll contact you soon.</p>
              </div>
            )}
            <div className="note">
              April 10th, 2027 - ONE DAY ONLY: 11:00 am - 6:00 pm at the Red Barn at the Southlands Tsawwassen. Admission is FREE
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container footer__inner">
          <div className="footer__brand" aria-label="South Delta Home Show">
            <img src={deltaLogo} alt="" className="footer__icon" aria-hidden="true" />
            <span className="brand__text">South Delta Home Show</span>
          </div>
          <div className="footer__meta">
            <span>6333 Market Ave, Delta, BC</span>
            <a href="mailto:info@southdeltahomeshow.ca">info@southdeltahomeshow.ca</a>
            <a href="tel:+16043655225">(604) 365‑5225</a>
          </div>
          <div className="footer__fine">© {new Date().getFullYear()} South Delta Home Show</div>
        </div>
      </footer>
    </div>
  );
}

export default App;
